<!--
 * @Author: cjh
 * @LastEditors: Du Feng
 * @Date: 2022-01-11 11:38:33
 * @LastEditTime: 2022-05-30 09:36:08
 * @Description: Modify here please
-->
<template>
  <div>
    <div class="detail">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          <span>课程详情</span>
        </div>
        <div class="right"></div>
      </div>
      <div class="info_header">
        <div class="info_header_item">
          <img :src="info.coverUrl" alt="" />
        </div>
        <div class="info_header_item">
          <div>
            <span style="margin-right: 10px;"> 课程名称: </span>
            <span> {{ info.cname || "无" }}</span>
          </div>
          <div>
            <span style="margin-right: 10px;"> 创建时间: </span>
            <span>
              {{ dayjs(info.createTime).format("YYYY.MM.DD") || "无" }}</span
            >
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-title">
          <img src="./img/title-1.svg" alt="" />
          <p>课程信息</p>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="课程介绍" name="first">
            <!-- ===============课程介绍板块====================-->
            <div
              class="main-li"
              v-for="(item, i) in list"
              :key="i + item.title"
            >
              <p>{{ item.title }}</p>
              <span
                v-if="item.text"
                :style="{ color: item.title === '附件' ? '#4991E1' : '' }"
                v-html="item.text"
              ></span>
              <span v-else>无</span>
            </div>
            <div class="coverAreas">
              <div class="coverAreas_right">课程覆盖区域</div>
              <div class="coverAreas_left">
                <p v-for="(item, i) in info.coverAreas" :key="i">
                  {{ item.proviceName || "" }}/{{ item.cityName || "" }}/{{
                    item.areaName || ""
                  }}
                </p>
              </div>
            </div>
            <div class="main-li">
              <p>视频介绍</p>
              <div class="file-box">
                <template v-for="(file, i) in info.resource">
                  <div
                    :key="i + 'files-zy'"
                    class="file-item"
                    v-if="file.source == '0'"
                  >
                    <img
                      :src="file.previewUrl"
                      alt=""
                      class="material-img"
                      v-if="getFileType(file.ext) === 'imgs'"
                    />
                    <video
                      v-else-if="getFileType(file.ext) === 'video'"
                      class="video-class"
                      :src="file.previewUrl"
                      controls
                      controlslist="nodownload"
                      :ref="'videoObj' + i"
                    ></video>
                  </div>
                </template>
                 <div v-if="table_3.length==0">无</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="info.mid" label="材料管理" name="material">
                  <mDetail
                  :info.sync="detail.info"
                ></mDetail>
          </el-tab-pane>
          <el-tab-pane label="教案课件" name="second">
            <!-- ===============教案课件板块====================-->
            <div class="main-title" style="margin-top: 30px">
              <img src="./img/title-2.svg" alt="" />
              <p>教案简案及详案</p>
            </div>
            <ul class="table">
              <div class="table-header">
                <div style="width: 15%">课时</div>
                <div style="width: 35%">教案</div>
                <div style="width: 15%">课时</div>
                <div style="width: 35%">教案</div>
              </div>
              <li v-for="(item, i) in table_1" :key="i + item.id">
                <div class="td-1">{{ i + 1 }}</div>
                <div class="td-2">
                  <div class="file">
                    <div>
                      <img src="./img/file-icon.svg" alt="" />
                      <span>{{ item.name || "无" }}</span>
                    </div>
                    <a href="javascript:;" @click="previewFile(item)">预览</a>
                  </div>
                </div>
              </li>
            </ul>

            <div class="main-title" style="margin-top: 50px">
              <img src="./img/title-3.svg" alt="" />
              <p>授课课件示例</p>
            </div>
            <div class="table" style="width: 50%">
              <div
                v-for="(item, i) in table_2"
                :key="item.id + i"
                class="table_2_tr"
              >
                <div class="td-1">示例课件{{ i + 1 || "无" }}</div>
                <div class="td-2">
                  <div class="file">
                    <div>
                      <img src="./img/file-icon.svg" alt="" />
                      <span>{{ item.name || "无" }}</span>
                    </div>
                    <a href="javascript:;" @click="previewFile(item)">预览</a>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="学校引入记录" name="import">
            <el-form :inline="true" :model="queryParams" label-width="70px">
              <el-form-item label="引入学校">
                <el-input
                  v-model="queryParams.orgName"
                  placeholder="请输入学校名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="操作内容">
                <el-select
                  v-model="queryParams.introduceState"
                  clearable
                  placeholder="请选择"
                  class="label"
                >
                  <el-option
                    v-for="item in importStateList"
                    :key="item.id + 'introduceState'"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" style="margin-left:20px">
                <el-button type="primary" size="small" @click="searchFun()"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
            <div class="table_import">
              <el-table :data="tableData" style="width: 100%" border>
                <el-table-column
                  prop="orgName"
                  label="引入学校"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="introduceTime"
                  label="操作时间"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{
                      dayjs(scope.row.introduceTime).format("YYYY-MM-DD HH:mm")
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="introduceState"
                  label="操作内容"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ importStateObj[scope.row.introduceState] || "" }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="creatorName"
                  label="操作者"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="creatorPhone"
                  label="联系电话"
                  align="center"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
              <div class="pagination">
                <el-pagination
                  background
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  :total="totalPage"
                  layout="total,prev, pager, next,jumper,sizes"
                  @size-change="sizeChangeHandle"
                  @current-change="currentChangeHandle"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div class="main-title" style="margin-top:50px">
          <img src="./img/title-4.svg" alt="" />
          <p>审核记录</p>
        </div>
        <!-- 课程审核-详情 -->
        <div>
          <div class="handle">
            <div
              v-for="(item, i) in operateList"
              :key="i + '审核记录'"
              class="handle-item"
            >
              <img
                src="./img/reject.svg"
                alt=""
                v-if="item.auditState === '3'"
              />
              <img src="./img/pass.svg" alt="" v-else />
              <div class="handle-title">
                <p v-if="item.auditState">{{ stateObj[item.auditState] }}</p>
                <p class="text">{{ item.operateOpinion }}</p>
              </div>
              <span class="handle-name">
                {{ item.operateOrgName || item.operateName }}
              </span>
              <span class="handle-time">
                {{ dayjs(item.operateTime).format("YYYY-MM-DD hh:mm") }}
              </span>
              <div class="line" v-if="i < item.operateOrgName.length - 1"></div>
            </div>
          </div>
          <template v-if="auditState == '1'">
            <div class="main-title" style="margin-top:50px">
              <img src="./img/title-5.svg" alt="" />
              <p>审核意见</p>
            </div>
            <el-input
              style="margin-top:20px"
              type="textarea"
              resize="none"
              :rows="6"
              placeholder="请输入"
              v-model="textarea"
            >
            </el-input>
          </template>
        </div>

        <!-- 课程管理-详情 -->
        <!-- <div v-if="type==='manager'">
        <div class="main-li">
          <p>审核时间</p>
          <span v-if="info.operateList&&info.operateList.length">{{ dayjs(info.operateList[info.operateList.length-1].operateTime).format('YYYY-MM-DD hh:mm') }}</span>
        </div>
        <div class="main-li">
          <p>审核单位</p>
          <span v-if="info.operateList&&info.operateList.length">{{info.operateList[info.operateList.length-1].operateOrgName}}</span>
        </div>
        <div class="main-li">
          <p>审核结果</p>
          <span v-if="info.operateList&&info.operateList[info.operateList.length-1].auditState">{{stateObj[info.operateList[info.operateList.length-1].auditState]}}</span>
        </div>
      </div> -->
      </div>
      <!-- 审核状态 0未审核，1审核中，2已审核，3未通过， -->
      <footer v-if="auditState == '1'">
        <el-button style="width:120px;" size="small" @click="toHandle('3')"
          >审核不通过</el-button
        >
        <el-button
          style="width:120px;margin-left:20px;"
          type="primary"
          size="small"
          @click="toHandle('2')"
          >审核通过</el-button
        >
      </footer>
      <footer v-if="auditState != '1' && isRevoke">
        <el-popover placement="top" width="200" v-model="visible">
          <div style="text-align: center;">
            <p style="margin:20px 0">确认撤销吗？</p>
            <el-button size="mini" type="text" @click="visible = false"
              >取消</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="(visible = false), handleUndo()"
              >确定</el-button
            >
          </div>
          <el-button type="primary" slot="reference">撤销</el-button>
        </el-popover>
      </footer>
    </div>
  </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import dayjs from "dayjs";
import util from "@/utils/util.js";
import {
  handleMaterialsDetail
} from "@/api/mechanismApi/curriculum.js";
import mDetail from "@/views/mechanism/supervise/materialDetail.vue";
export default {
  props: ["info", "type", "auditState"],
  components: {mDetail},
  data() {
    return {
      visible: false,
      activeName: "first",
      list: [
        { title: "课程类型", text: "" },
        { title: "教学目的", text: "" },
        { title: "适用年级", text: "" },
        { title: "课程特点", text: "" },
        { title: "授课时间安排", text: "" },
        { title: "课程描述", text: "" },
      ],
      stateObj: {
        1: "申请审核",
        2: "审核通过",
        3: "审核不通过",
        4: "已下架",
      },
      detail: {
        info: {},
        show: false,
      },
      isRevoke: false, //是否有撤销的权限
      table_1: [],
      table_2: [],
      table_3: [],
      m_info: {},
      textarea: "",
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      tableData: [],
      queryParams: {
        orgName: "",
        introduceState: "",
      },
      importStateList: [
        { label: "引入课程", id: "1" },
        { label: "取消引入课程", id: "0" },
      ],
      importStateObj: {
        "1": "引入课程",
        "0": "取消引入课程",
      },
      operateList: [],
    };
  },
  computed: {},
  watch: {
    info: {
      async handler(n, o) {
        console.log('详情页审核状态__',this.auditState);
        let vm = this.info;
        if (!vm.resource) vm.resource = [];
        let str = `课时总数：${vm.periodTotal}课时<br/> 课时时长：${vm.periodTime}分钟<br/> 上课频率：${vm.frequency}次/周`;
        let areaArr = [];
        if (vm.coverAreas[0].proviceName)
          areaArr.push(vm.coverAreas[0].proviceName);
        if (vm.coverAreas[0].cityName) areaArr.push(vm.coverAreas[0].cityName);
        if (vm.coverAreas[0].areaName) areaArr.push(vm.coverAreas[0].areaName);
        let area = areaArr.join("/");
        this.list = [
          { title: "报审单位", text: vm.orgName },
          { title: "课程价格", text: vm.price },
          { title: "课程类型", text: vm.typeName },
          { title: "教学目的", text: vm.teachAims },
          { title: "适用年级", text: util.getGrade(vm.scope) },
          { title: "课程特点", text: vm.feature },
          { title: "授课时间安排", text: str },
          { title: "课程描述", text: vm.description },
        ];
        this.table_1 = vm.resource.filter((e) => e.source === "2");
        this.table_2 = vm.resource.filter((e) => e.source === "3");
        this.table_3 = vm.resource.filter((e) => e.source === "0");
        this.getDataList();
        this.getRecordList(this.info.cid);
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    dayjs,
    async getRecordList(cid) {
      let params = {
        cid: cid,
        orgId: sessionStorage.getItem("orgId"),
      };
      let res = await educationApi.getEducationCourseauditrecord(params);
      if (res.result === "000000") {
        this.operateList = res.data || [];
        this.revokeShow(res.data);
      } else {
        this.$message({
          type: "error",
          message: "获取审核记录失败",
        });
      }
    },
    // 确认当前用户的审核权限
    revokeShow(list) {
      let userId = JSON.parse(sessionStorage.getItem("Userlist")).userId;
      var operateObj = [...list].pop();
      console.log("------------", operateObj, userId, this.auditState);
      if (
        (this.auditState == "2" && operateObj.operateId == userId) ||
        (this.auditState == "3" && operateObj.operateId == userId)
      ) {
        this.isRevoke = true;
      } else {
        this.isRevoke = false;
      }
      // let revokeList=[]
      // if(this.info.operateList.length>0){
      //      this.info.operateList.forEach(it => {
      //         if(it.auditState=="2"){
      //            revokeList.push(it)
      //         }
      //    });
      // }
      //  if(revokeList.length==1 && revokeList[0].operateId==userId){
      //    console.log('走-------1');
      //    this.isRevoke=true
      //   }else if(revokeList.length>1){
      //      console.log('审核记录-----',revokeList);
      //     console.log('最后一个通过的-----',revokeList.pop(),userId);
      //     if(revokeList.pop().operateId==userId){
      //       console.log('aaaaaaaa');

      //         this.isRevoke=true
      //     }else{
      //        console.log('bbbbbbb');
      //       this.isRevoke=false
      //     }
      //     // let operateTimeArr=[]
      //     // let revokeListCopy=JSON.parse(JSON.stringify(revokeList))
      //     //   revokeListCopy.forEach(it=>{
      //     //      it.operateTime=new Date(dayjs(it.operateTime).format("YYYY-MM-DD hh:mm:ss")).getTime()
      //     //      console.log('每一项--',it);
      //     //      operateTimeArr.push(it.operateTime)
      //     //   })
      //     //    this.getMath(operateTimeArr)
      //     //      console.log('审核记录-----',revokeListCopy);
      //     //    revokeListCopy.forEach(fit=>{
      //     //       if(fit.operateTime=this.getMath(operateTimeArr) && fit.operateId=== userId ){
      //     //          console.log('最大项----fit',fit);
      //     //         this.isRevoke=true
      //     //       }else{
      //     //         this.isRevoke=false
      //     //       }
      //     //    })
      //   }else{
      //     console.log('走-------3');
      //     this.isRevoke=false
      //   }
    },
    getFileType(ext) {
      return util.getFileType(ext);
    },
    toIndex() {
      this.$emit("to-index");
    },
    handleClick(tab, event) {
      if(tab.name=='material'){
          this.toMDetail()
      }
      this.activeName = tab.name;
    },
    previewFile(item) {
      window.open(item.previewUrl);
    },
    async toHandle(state) {
      if (!this.textarea) {
        this.$message({ type: "error", message: "审核意见不能为空" });
        return false;
      }
      let params = {
        cid: this.info.cid,
        auditState: state,
        operateOpinion: this.textarea,
        orgId: this.info.orgId,
      };
      let api =
        this.info.orgType === "2"
          ? "educationCourseOperateOfSchool"
          : "educationCourseOperate";
      console.log("请求方式", this.info.orgType, api);
      // return
      let res = await educationApi[api](params);
      if (res.result == "000000") {
        this.$message({ type: "success", message: "操作成功" });
        this.textarea = "";
        this.$emit("to-init");
        this.toIndex();
      } else {
        this.$message({ type: "error", message: "操作失败" });
      }
    },
    async getDataList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cid: this.info.cid,
        orgName: this.queryParams.orgName,
        introduceState: this.queryParams.introduceState,
      };
      let res = await educationApi.getCourseOrgintroduce(params);
      if (res.result == "000000") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
      }
    },
    // 已审核的课程经常撤销操作
    async handleUndo() {
      let params = {
        loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
        platformCode: sessionStorage.getItem("platformCode"),
        usessionid: sessionStorage.getItem("usessionid"),
        cid: this.info.cid,
        orgId: sessionStorage.getItem("orgId"),
      };
      let res = await educationApi.getEducationCourseUndo(params);
      if (res.result == "000000") {
        this.$message({ type: "success", message: "撤销成功" });
        this.$emit("to-init");
        this.toIndex();
      } else {
        this.$message({ type: "error", message: "撤销失败" });
      }
    },
    async toMDetail() {
      let params = {
        mid: this.info.mid,
      };
      var { result, data } = await handleMaterialsDetail(params);
      if (result == "000000") {
        this.detail.info = data;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .main-li {
      margin-top: 20px;
      width: 100%;
      display: flex;
      // align-items: center;
      font-size: 14px;
      color: #888;
      p {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      span {
        width: calc(100% - 150px);
        word-wrap: break-word;
      }
    }
    .coverAreas {
      display: flex;
      margin-top: 20px;
      width: 100%;
      font-size: 14px;
      color: #888;
      .coverAreas_right {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      .coverAreas_left {
        width: 200px;
        word-wrap: break-word;
        p {
          width: 500px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      height: 100%;
      float: left;
    }
    .td-2 {
      width: 70%;
      height: 100%;
      float: right;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 48px;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    width: 100%;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }

  .handle-item {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    padding-left: 80px;
    position: relative;
    .line {
      position: absolute;
      width: 1px;
      height: calc(100% + 10px);
      background: #eeeeee;
      left: 90px;
      top: calc(50% - 5px);
    }
    .handle-title {
      width: 50%;
      margin-left: 15px;
      .text {
        color: #888;
      }
    }
    .handle-name {
      min-width: 120px;
      text-align: right;
    }
    .handle-time {
      margin-left: 20px;
      color: #888;
    }
  }

  .price-box {
    display: flex;
    align-items: center;
    margin-top: 30px;
    span {
      width: 80px;
      color: #888;
    }
    ::v-deep .el-input__inner {
      height: 32px;
    }
  }
}

.info_header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .info_header_item {
    img {
      height: 80px;
      max-width: 500px;
    }
    div {
      margin: 15px;
    }
  }
}
::v-deep .el-tabs__nav {
  height: 45px !important;
  margin-top: 10px !important;
}
.video-class {
  max-width: 300px;
}
footer {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.pagination {
  text-align: center;
  margin-top: 30px;
}
</style>
